import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({
            title: lang === "hu" ? "Felhasználási feltételek" : "Terms of usage",
            allMessage,
            lang,
            type: "article",
        });
    },
};
